module.exports = ":host{\n    width: 100%;\n}\n.form-control {\n    min-height: 25px;\n}"